import { Component, computed, Input, QueryList, signal, ViewChildren } from '@angular/core';
import { PER_PAGE } from '@microsec/constants';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { RulesetRuleTypeFieldComponent } from '../ruleset-rule-type-field/ruleset-rule-type-field.component';
import { BaseComponent } from '@ids-components';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { AccordionModule } from 'primeng/accordion';

@Component({
  selector: 'app-ruleset-rule-type',
  templateUrl: './ruleset-rule-type.component.html',
  styleUrls: ['./ruleset-rule-type.component.scss'],
  imports: [PaginatorModule, ToggleSwitchModule, AccordionModule, RulesetRuleTypeFieldComponent],
})
export class RulesetRuleTypeComponent extends BaseComponent {
  @Input() ruleTypes: any[] = [];

  @ViewChildren(RulesetRuleTypeFieldComponent) ruleTypeFields!: QueryList<RulesetRuleTypeFieldComponent>;

  //----------------- Pagination -----------------------
  paginator = signal<PaginatorState>({ page: 1, first: 0, rows: 10, pageCount: undefined });

  PER_PAGE = PER_PAGE;

  displayRuleTypes = computed<any[]>(() => {
    const paginatorState = this.paginator();
    const start = paginatorState.first || 0;
    const end = start + (paginatorState.rows || 10);
    return this.ruleTypes.slice(start, end);
  });

  totalRecords = computed<number>(() => this.ruleTypes.length || 0);

  constructor() {
    super();
  }

  onPageChange(event: any) {
    if (this.paginator().rows !== event.rows || this.paginator().first !== event.first || this.paginator().page !== event.page) {
      this.paginator.set({ ...event });
    }
  }
}
